import { AddCircle, Document, Trash } from "iconsax-react";
import React, { useState } from "react";
import * as RB from "react-bootstrap";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";

function BankDetails({ bankDetails, setBankDetails }) {
  const [isChequeDragging, setIsChequeDragging] = useState(false);
  const [isValidCheque, setIsValidCheque] = useState(true);

  // Handle changes in form fields (like account name, number, etc.)
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;
    setBankDetails((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  // Handle the upload of new images
  const handleChequeUpload = (e) => {
    const files = Array.from(e.target.files);
    handleChequeFiles(files);
  };

  // Validate and add files to the state (newly uploaded images)
  const handleChequeFiles = (files) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    const validFiles = files.filter((file) => allowedTypes.includes(file.type));

    if (validFiles.length !== files.length) {
      setIsValidCheque(false);
      alert("Only PDF, JPG, JPEG, and PNG files are allowed.");
      return;
    } else {
      setIsValidCheque(true);
    }

    // Add the new files to the `newCancelCheques` state (separate state for new files)
    setBankDetails((prev) => ({
      ...prev,
      newCancelCheques: [...(prev.newCancelCheques || []), ...validFiles],
    }));
  };

  // Handle the deletion of images, both API and newly added
  const removeCheque = (index, isFromServer, imageId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this file?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (isFromServer) {
          utils
            .callAPI("get", `/vendors/delete-cheque?imageId=${imageId}`)
            .then((res) => {
              if (typeof res !== "undefined") {
                const updatedFiles = (bankDetails.cancelCheque || []).filter(
                  (_, i) => i !== index
                );
                setBankDetails((prev) => ({
                  ...prev,
                  cancelCheque: updatedFiles,
                }));
              } else {
              }
            })
            .catch((err) => {});
        } else {
          const updatedFiles = (bankDetails.newCancelCheques || []).filter(
            (_, i) => i !== index
          );
          setBankDetails((prev) => ({
            ...prev,
            newCancelCheques: updatedFiles,
          }));
        }
      }
    });
  };

  // Drag and Drop functionality for file upload
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsChequeDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsChequeDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsChequeDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsChequeDragging(false);
    const files = Array.from(e.dataTransfer.files);
    handleChequeFiles(files);
  };

  const isPdfFile = (file) => {
    // For API files (with url) check the extension:
    if (file.url) {
      return file.url.toLowerCase().endsWith(".pdf");
    }
    // For newly uploaded files (File objects), check file.type
    if (file.type) {
      return file.type === "application/pdf";
    }
    return false;
  };

  return (
    <>
      <h6 className="mt-4">Bank Details</h6>
      <hr className="hr-lg" />
      <RB.Row>
        <RB.Col md={6}>
          <RB.FloatingLabel
            controlId="accountName"
            label="Account Name"
            className="mb-3 floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="accountName"
              placeholder="Account Name"
              value={bankDetails.accountName}
              onChange={handleChange}
              required
              title="Only letters and spaces allowed"
            />
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={6}>
          <RB.FloatingLabel
            controlId="accountNumber"
            label="Account Number"
            className="mb-3 floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              placeholder="Account Number"
              name="accountNumber"
              value={bankDetails.accountNumber}
              onChange={handleChange}
              required
              title="Only numeric values allowed"
            />
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={6}>
          <RB.FloatingLabel
            controlId="bankName"
            label="Bank Name"
            className="mb-3 floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="bankName"
              value={bankDetails.bankName}
              placeholder="Bank Name"
              onChange={handleChange}
              required
              title="Only letters and spaces allowed"
            />
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={6}>
          <RB.FloatingLabel
            controlId="ifscCode"
            label="IFSC Code"
            className="mb-3 floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="ifscCode"
              value={bankDetails.ifscCode}
              placeholder="IFSC Code"
              onChange={handleChange}
              required
            />
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={6}>
          <RB.FloatingLabel
            controlId="branch"
            label="Branch"
            className="mb-3 floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="branch"
              placeholder="Branch"
              value={bankDetails.branch}
              onChange={handleChange}
              required
            />
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={12}>
          <h6 className="mb-1">Cancel Cheque</h6>
          <hr />
          <div
            className={`border p-4 text-center d-flex flex-column align-items-center ${
              isChequeDragging ? "bg-info" : ""
            }`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className="avatar avatar-circle avatar-lg bg-light text-dark">
              <i className="material-icons-outlined">cloud_upload</i>
            </div>
            <p className="mb-0">Drag & Drop your Cancel Cheque files here</p>
            <small className="mb-2">or</small>
            <div>
              <input
                type="file"
                accept=".pdf, .jpg, .jpeg, .png"
                multiple
                style={{ display: "none" }}
                onChange={handleChequeUpload}
                id="chequeFileInput"
              />
              <RB.Button
                variant="primary"
                onClick={() =>
                  document.getElementById("chequeFileInput").click()
                }
              >
                <i className="las la-file-upload me-1"></i>Browse Files
              </RB.Button>
            </div>
          </div>
          <span className={`${!isValidCheque ? "text-danger" : ""}`}>
            <small>*Note: Only PDF, JPG, JPEG and PNG Files are allowed</small>
          </span>

          <RB.Row className="mt-3 g-3">
            {[
              ...(bankDetails.cancelCheque || []),
              ...(bankDetails.newCancelCheques || []),
            ].map((file, index) => {
              const pdf = isPdfFile(file);

              return (
                <RB.Col md={6} lg={4} key={index}>
                  <div
                    className="position-relative mb-4"
                    style={{ maxHeight: "200px" }}
                  >
                    <div
                      className="product-image-upload d-flex flex-column align-items-center justify-content-center border"
                      style={{
                        height: "200px",
                        cursor: pdf ? "default" : "pointer",
                        padding: "10px",
                        position: "relative",
                      }}
                    >
                      {file.isFromServer ? (
                        pdf ? (
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <Document
                              size={64}
                              color="#E02E2E"
                              variant="Bold"
                            />
                            <p
                              style={{
                                wordBreak: "break-word",
                                textAlign: "center",
                              }}
                            >
                            PDF
                            </p>
                          </a>
                        ) : (
                          <img
                            src={file.url}
                            alt={`Cheque ${index}`}
                            style={{ maxHeight: "180px", objectFit: "cover" }}
                          />
                        )
                      ) : pdf ? (
                        <a
                          href={URL.createObjectURL(file)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <Document size={64} color="#E02E2E" variant="Bold" />
                          <p
                            style={{
                              marginTop: "10px",
                              wordBreak: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {file.name}
                          </p>
                        </a>
                      ) : (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`Cheque ${index}`}
                          style={{ maxHeight: "180px", objectFit: "cover" }}
                        />
                      )}
                    </div>

                    <RB.Button
                      variant="danger"
                      className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                      onClick={() =>
                        removeCheque(index, file.isFromServer, file.imageId)
                      }
                    >
                      <i className="material-icons-outlined">delete</i>
                    </RB.Button>
                  </div>
                </RB.Col>
              );
            })}
          </RB.Row>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default BankDetails;
